export default {
    'types': {
        "query": "query",
        "mutation": "mutation"
    }
};